import AbstractModel from './AbstractModel';
import {ILocalisationMessage} from '../../../@interfaces/services/Database';

export default class LocalisationMessage extends AbstractModel<ILocalisationMessage> implements ILocalisationMessage {
	locale!: string;
	component!: string;
	key!: string;
	message!: string;

	protected get table() {
		return this.connection.localisations;
	}
}
